import { useRevealedText } from '../hooks/useRevealedText';
import { SoteriaMarkdown } from './SoteriaMarkdown';

/**
 * RevealingMarkdown
 * -----------------
 * An assistant reply that types itself in while the turn is live, and renders
 * whole once it isn't.
 *
 * A component rather than a call inside the message loop because the reveal
 * needs its own state per message, and hooks can't be called conditionally. It
 * decides what to do from the state it mounts in: live → type, finished →
 * show everything. That is what stops history re-typing itself every time the
 * list re-renders or the page reloads.
 *
 * The animation is display-only. The full text stays in the message, so copy,
 * text-to-speech and the audit all see the complete reply regardless of how much
 * has been painted.
 */
export function RevealingMarkdown({
  content,
  streaming,
}: {
  content: string;
  streaming: boolean;
}) {
  const visible = useRevealedText(content, streaming);
  return <SoteriaMarkdown content={visible} />;
}
